<template>
    <div>
        <header-portrate />
        <exports-print ref="exportbar" />

        <div>
            <tabsComp :tabs="tabs" />

            <v-row class="mainrow m-2" :style="`direction:`+lang.dir+`;margin-top:-10px !important;`">
                <v-row class="mt-10">
                    <v-col cols="12" md="12" sm="12">
                        <form autocomplete="off" @submit.prevent="getReport()">
                        <v-row>
                            <v-col cols="12" md="2" sm="6">
                                <label>{{ lang.start_date }}</label>
                                <b-form-input class="inborder" type="date" v-model="sdate" />
                            </v-col>
                            <v-col cols="12" md="2" sm="6">
                                <label>{{ lang.end_date }}</label>
                                <b-form-input class="inborder" type="date" v-model="edate" />
                            </v-col>
                            <v-col cols="12" md="2" sm="6">
                                <label>{{ lang.group_by }}</label>
                                <b-form-select class="selborder" v-model="group_by" :options="groupByOptions" @change="userid = 0" />
                            </v-col>
                            <v-col cols="12" md="2" sm="6">
                                <label>{{ group_by == 'creator' ? lang.issued_by : lang.salesman }}</label>
                                <b-form-select class="selborder" v-model="userid" :options="usersVals" />
                            </v-col>
                            <v-col cols="12" md="2" sm="6">
                                <label>&nbsp;</label>
                                <b-input-group>
                                    <b-button variant="light" type="submit" style="padding-top:2px !important; padding-bottom:2px !important;background:blue;color:#fff;width:75px;">{{ lang.search }}</b-button>
                                </b-input-group>
                            </v-col>
                        </v-row>
                        </form>
                    </v-col>

                    <v-col cols="12" md="12" sm="12">
                        <v-data-table
                            :headers="headers"
                            :items="tbRows"
                            hide-default-footer
                            disable-pagination
                        >
                            <template v-slot:header="">
                                <thead>
                                    <tr>
                                        <th class="text-center" :colspan="headers.length" style="font-weight:bold;font-size:1rem;">
                                            {{ lang.salesman_report }} - {{ group_by == 'creator' ? lang.issued_by : lang.salesman }}
                                            <span v-if="sdate || edate"> ({{ sdate }} - {{ edate }})</span>
                                        </th>
                                    </tr>
                                </thead>
                            </template>
                            <template v-slot:item="row">
                                <tr @click="showDetails(row.item)" style="cursor:pointer;" :style="row.item.userid == userid ? 'background:#e8f0fe;' : ''">
                                    <td class="text-center">{{ row.item.user_name }}</td>
                                    <td class="text-center">{{ row.item.invoices_count }}</td>
                                    <td class="text-center">{{ $RoundNum(row.item.total,2) }}</td>
                                    <td class="text-center">{{ $RoundNum(row.item.discount,2) }}</td>
                                    <td class="text-center">{{ $RoundNum(row.item.vat,2) }}</td>
                                    <td class="text-center">{{ $RoundNum(row.item.ftotal,2) }}</td>
                                    <td class="text-center">{{ $RoundNum(row.item.paid,2) }}</td>
                                    <td class="text-center">{{ $RoundNum(row.item.remaining,2) }}</td>
                                    <td class="text-center">{{ row.item.returns_count }}</td>
                                    <td class="text-center">{{ $RoundNum(row.item.returns_total,2) }}</td>
                                    <td class="text-center" style="font-weight:bold;">{{ $RoundNum(row.item.net_total,2) }}</td>
                                </tr>
                            </template>
                            <template v-slot:body.append="" v-if="tbRows.length > 0">
                                <tr style="background:#eee;font-weight:bold;">
                                    <td class="text-center">{{ lang.totals }}</td>
                                    <td class="text-center">{{ sum(tbRows,'invoices_count',0) }}</td>
                                    <td class="text-center">{{ sum(tbRows,'total') }}</td>
                                    <td class="text-center">{{ sum(tbRows,'discount') }}</td>
                                    <td class="text-center">{{ sum(tbRows,'vat') }}</td>
                                    <td class="text-center">{{ sum(tbRows,'ftotal') }}</td>
                                    <td class="text-center">{{ sum(tbRows,'paid') }}</td>
                                    <td class="text-center">{{ sum(tbRows,'remaining') }}</td>
                                    <td class="text-center">{{ sum(tbRows,'returns_count',0) }}</td>
                                    <td class="text-center">{{ sum(tbRows,'returns_total') }}</td>
                                    <td class="text-center">{{ sum(tbRows,'net_total') }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                        <div v-if="tbRows.length > 0 && invoices.length == 0" class="text-center mt-2" style="color:#777;">{{ lang.select_user_for_details }}</div>
                    </v-col>

                    <v-col cols="12" md="12" sm="12" style="margin-bottom:80px;" v-if="invoices.length > 0">
                        <v-data-table
                            :headers="detailHeaders"
                            :items="invoices"
                            hide-default-footer
                            disable-pagination
                        >
                            <template v-slot:header="">
                                <thead>
                                    <tr>
                                        <th class="text-center" :colspan="detailHeaders.length" style="font-weight:bold;font-size:1rem;">
                                            {{ lang.invoice_details }} - {{ selectedName }}
                                        </th>
                                    </tr>
                                </thead>
                            </template>
                            <template v-slot:item="row">
                                <tr :style="row.item.invtype == 3 ? 'color:red;' : ''">
                                    <td class="text-center">{{ row.item.invoice_number }}</td>
                                    <td class="text-center">{{ row.item.inv_date }}</td>
                                    <td class="text-center">{{ row.item.customer_name }}</td>
                                    <td class="text-center">{{ row.item.mobile }}</td>
                                    <td class="text-center">{{ row.item.agent_name }}</td>
                                    <td class="text-center">{{ row.item.created_by_name }}</td>
                                    <td class="text-center">{{ $RoundNum(row.item.total,2) }}</td>
                                    <td class="text-center">{{ $RoundNum(row.item.vat,2) }}</td>
                                    <td class="text-center">{{ $RoundNum(row.item.ftotal,2) }}</td>
                                    <td class="text-center">{{ $RoundNum(row.item.paid,2) }}</td>
                                    <td class="text-center">{{ $RoundNum(row.item.remaining,2) }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-row>
        </div>
        <Footer />
    </div>
</template>

<script>
import HeaderPortrate from '@/components/Header-Portrate.vue';
import ExportsPrint from '@/components/exports-print.vue';
import Footer from '@/components/Footer.vue';
import tabsComp from '@/components/tabsComp.vue'
import axios from 'axios'
import { getVisibleTabsForRoute } from '@/menu/menuService'

const today = () => (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);

export default {
    components: {
        ExportsPrint, Footer, tabsComp, HeaderPortrate
    },
    data() {
        return {
            tbRows: [],
            invoices: [],
            users: [],
            sdate: today().substr(0, 8) + '01',
            edate: today(),
            group_by: 'agent',
            userid: 0,
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        groupByOptions: function(){
            return [
                { text: this.lang.salesman, value: 'agent' },
                { text: this.lang.issued_by, value: 'creator' },
            ]
        },
        usersVals: function(){
            const t = [{ text: this.lang.all, value: 0 }];
            for(let i = 0; i < this.users.length; i++){
                t.push({ text: this.users[i].full_name, value: Number(this.users[i].id) });
            }
            return t;
        },
        selectedName: function(){
            const u = this.users.find((x) => Number(x.id) == Number(this.userid));
            return u ? u.full_name : '';
        },
        headers: function(){
            const h = (text) => ({ text, align: 'center', sortable: false, class: 'backBlack', printRemove: 0 });
            return [
                h(this.group_by == 'creator' ? this.lang.issued_by : this.lang.salesman),
                h(this.lang.invoices_count),
                h(this.lang.total),
                h(this.lang.discount),
                h(this.lang.vat),
                h(this.lang.ftotal),
                h(this.lang.paid),
                h(this.lang.remain),
                h(this.lang.returns_count),
                h(this.lang.returns_total),
                h(this.lang.net_total),
            ]
        },
        detailHeaders: function(){
            const h = (text) => ({ text, align: 'center', sortable: false, class: 'backBlack', printRemove: 0 });
            return [
                h(this.lang.invoiceno),
                h(this.lang.invoice_date),
                h(this.lang.customer_name),
                h(this.lang.mobile),
                h(this.lang.salesman),
                h(this.lang.issued_by),
                h(this.lang.total),
                h(this.lang.vat),
                h(this.lang.ftotal),
                h(this.lang.paid),
                h(this.lang.remain),
            ]
        },
        tabs: function() {
            return getVisibleTabsForRoute(this.$store.getters['state'], this.lang, this.$route.path);
        },
    },
    methods: {
        sum(rows, key, digits = 2){
            const s = rows.reduce((a, r) => a + (parseFloat(r[key]) || 0), 0);
            return this.$RoundNum(s, digits);
        },
        showDetails(item){
            this.userid = Number(item.userid);
            this.getReport();
        },
        getReport(){
            const post = new FormData();
            post.append('type','getSalesmanReport');
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[lang]',this.lang.langname);
            post.append('data[sdate]',this.sdate);
            post.append('data[edate]',this.edate);
            post.append('data[group_by]',this.group_by);
            post.append('data[userid]',this.userid);

            this.$store.state.showLoading = true
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((response) => {
                this.$store.state.showLoading = false
                const res = response.data.results || {};
                this.tbRows = Array.isArray(res.data) ? res.data : [];
                this.invoices = Array.isArray(res.invoices) ? res.invoices : [];
                if(Array.isArray(res.users)) this.users = res.users;
            }).catch(() => {
                this.$store.state.showLoading = false
            });
        }
    },
    created(){
        this.getReport()
    }
}
</script>
